export default "__VITE_ASSET__BqlxHLoH__"